
/* eslint-disable */
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { getEventMouseOrTouchXY, isAdminOrRoomAdmin } from '@/utils/functions';
import {
  BoundingPosition,
  CoordinatesPosition,
  DesktopRoomObject,
  Room,
  RoomObject,
  User,
  UserRoomStateData,
  zawaroom,
} from '@/utils/models';
import { JitsiParticipant, TrackAndElement } from '@/service/JitsiLibWrapper';
import Board from './Board.vue';
import { YOUTUBE_PREFIX_URL } from '@/utils/constants';

@Component({ components: { Board } })
export default class RoomObjectDisplayer extends Vue {
  @Prop() room!: Room;
  @Prop() roomObject!: RoomObject | DesktopRoomObject;
  @Prop() private scale!: number;
  @Prop() isEnteredRoomObject!: boolean;

  @Emit() private changePosition(arg: { newPosition: CoordinatesPosition; roomObject: RoomObject }) {}
  @Emit() private changeSize(args: { newSize: BoundingPosition; roomObject: RoomObject }) {}
  @Emit() onPointerLeaveClearObject(roomObject: RoomObject | DesktopRoomObject) {}
  @Emit() onPointerEnterSetObject(ev: PointerEvent, roomObject: RoomObject | DesktopRoomObject) {}
  @Emit() onPointerMove() {}

  //#region 表示用プロパティ
  get user(): User {
    return this.$store.state.user;
  }
  get isAdminOrRoomAdmin(): boolean {
    return isAdminOrRoomAdmin(this.user, this.room);
  }
  get isShareScreen(): boolean {
    return this.roomObject.objectType === 'share screen';
  }
  get isShareScreenHidden(): boolean {
    return this.isShareScreen && (this.roomObject as DesktopRoomObject).hidden;
  }
  get isShareScreenVisible(): boolean {
    return this.isShareScreen && !(this.roomObject as DesktopRoomObject).visible;
  }
  get isBoard(): boolean {
    return this.roomObject.objectType === 'board';
  }
  get isImage(): boolean {
    return (
      this.roomObject.objectType === 'image' ||
      (this.roomObject.objectType === 'board' && this.roomObject.props.boardType === 'image')
    );
  }
  get isIframe(): boolean {
    return this.roomObject.objectType === 'board' && this.roomObject.props.boardType === 'iframe';
  }
  get isLocked(): boolean {
    return this.roomObject.isLocked ?? false;
  }
  get roomScale(): number {
    return this.scale;
  }
  get boardScale(): number {
    return this.roomObject.size / this.roomObject.height;
  }
  get boardWidth(): string {
    return this.roomObject.width ? this.roomObject.width + 'px' : 'auto';
  }
  get url(): string | undefined {
    return this.roomObject.props?.url;
  }
  get tooltip(): string {
    return this.roomObject.props?.tooltip ?? '';
  }
  get iframeUrl(): string {
    const localIframeUrl = this.roomObject.props.iframeUrl || 'about:blank';
    const possiblePrefixes = [
      'https://www.youtube.com/embed/',
      'https://www.youtube.com/watch?v=',
      'https://youtu.be/',
    ];
    const matchedPrefix = possiblePrefixes.find((p) => localIframeUrl.startsWith(p));
    return this.roomObject.props.iframeUrlType === 'youtube' && matchedPrefix
      ? `${YOUTUBE_PREFIX_URL}${localIframeUrl.substring(matchedPrefix.length)}`
      : localIframeUrl;
  }
  get isRoomObjectHover(): boolean {
    return this.$store.state.isRoomObjectHover;
  }
  get isRoomObjectMenuHover(): boolean {
    return this.$store.state.isRoomObjectMenuHover;
  }
  //#endregion

  isDesktopMounted: boolean = false;

  private moveStartPos: BoundingPosition = { x: 200, y: 200, width: 200, height: 200 };
  private moveStartMousePos: CoordinatesPosition = { x: 200, y: 200 };
  private mode: 'move' | 'resize' = 'move';

  get author(): string {
    return this.roomObject.createdUserName;
  }
  get isCheckedRoomTypeAll() {
    return this.roomObject.roomType === 'all';
  }

  unlockEventTimer: any = 0;

  mounted() {
    if (this.isShareScreen) {
      let ro = this.roomObject as DesktopRoomObject;
      ro.createdUserParticipant?.on('tracksUpdate', this.onTracksUpdate);
      if (ro.createdUserParticipant?.desktopTrack) {
        this.onTracksUpdate(ro.createdUserParticipant.desktopTrack);
      }
    }
  }
  beforeDestroy() {
    if (this.isShareScreen) {
      let ro = this.roomObject as DesktopRoomObject;
      ro.createdUserParticipant?.off('tracksUpdate', this.onTracksUpdate);
    }
    if (this.subWindow) {
      this.subWindow.close();
    }
  }
  private onChangePosition(newPosition: CoordinatesPosition) {
    this.changePosition({ newPosition, roomObject: this.roomObject });
  }

  //#region 移動処理
  onPointerDownHandler(e: PointerEvent) {
    const el = e.currentTarget as HTMLElement;
    const containerEl = this.$refs.container as HTMLDivElement;
    const startWitdh = this.isShareScreen || this.isImage ? containerEl.clientWidth : this.roomObject.width;
    e.stopPropagation();
    el.addEventListener('pointermove', this.onMouseMoveHandler);
    el.setPointerCapture(e.pointerId);
    this.moveStartPos = {
      x: this.roomObject.position.x,
      y: this.roomObject.position.y,
      width: startWitdh,
      height: this.roomObject.size,
    };
    const pointerPosition: CoordinatesPosition = getEventMouseOrTouchXY(e);
    this.moveStartMousePos = pointerPosition;
    this.mode = el.classList.contains('resize-and-move') ? 'move' : 'resize';
  }
  private onMouseMoveHandler(e: PointerEvent | TouchEvent) {
    if (!e) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    const pointerPosition: CoordinatesPosition = getEventMouseOrTouchXY(e);
    const diff: CoordinatesPosition = {
      x: Math.round((pointerPosition.x - this.moveStartMousePos.x) / this.roomScale),
      y: Math.round((pointerPosition.y - this.moveStartMousePos.y) / this.roomScale),
    };
    if (this.mode === 'move') {
      this.onMouseMoveMoveModeHandler(diff);
    } else {
      let el = e.target as HTMLDivElement;
      let pos = Array.from(el.classList).find((c) => c !== 'resize-handler');
      if (pos) {
        this.onMouseMoveResizeModeHandler(diff, pos);
      }
    }
  }
  private onMouseMoveMoveModeHandler(diff: CoordinatesPosition) {
    const newPos: CoordinatesPosition = {
      x: this.moveStartPos.x + diff.x,
      y: this.moveStartPos.y + diff.y,
    };
    this.onChangePosition(this.updateBounding(newPos));
  }
  private onMouseMoveResizeModeHandler(diff: CoordinatesPosition, pos: string) {
    const start = this.moveStartPos;
    const newSize: BoundingPosition = { x: 0, y: 0, width: 0, height: 0 };
    switch (pos) {
      case 'north':
        newSize.x = start.x;
        newSize.y = start.y + diff.y;
        newSize.width = start.width;
        newSize.height = Math.max(0, start.height - diff.y);
        break;
      case 'south':
        newSize.x = start.x;
        newSize.y = start.y;
        newSize.width = start.width;
        newSize.height = Math.max(0, start.height + diff.y);
        break;
      case 'west':
        newSize.x = start.x + diff.x;
        newSize.y = start.y;
        newSize.width = Math.max(0, start.width - diff.x);
        newSize.height = start.height;
        break;
      case 'east':
        newSize.x = start.x;
        newSize.y = start.y;
        newSize.width = Math.max(0, start.width + diff.x);
        newSize.height = start.height;
        break;
      case 'nw':
        if (this.isShareScreen || this.isImage) {
          //画面サイズはheightにより決定され、widthはheightに比例して変化する。diff.xはハンドルの移動量であり、画面のwidthの変化量ではない。画面のwidthの変化量は diff.y * (start.width / start.height)で求める。
          newSize.x = start.x + diff.y * (start.width / start.height);
        } else {
          newSize.x = start.x + diff.x;
        }
        newSize.y = start.y + diff.y;
        newSize.width = Math.max(0, start.width - diff.x);
        newSize.height = Math.max(0, start.height - diff.y);
        break;
      case 'ne':
        newSize.x = start.x;
        newSize.y = start.y + diff.y;
        newSize.width = Math.max(0, start.width + diff.x);
        newSize.height = Math.max(0, start.height - diff.y);
        break;
      case 'sw':
        if (this.isShareScreen || this.isImage) {
          //画面サイズはheightにより決定され、widthはheightに比例して変化する。diff.xはハンドルの移動量であり、画面のwidthの変化量ではない。画面のwidthの変化量は diff.y * (start.width / start.height)で求める。
          newSize.x = start.x - diff.y * (start.width / start.height);
        } else {
          newSize.x = start.x + diff.x;
        }
        newSize.y = start.y;
        newSize.width = Math.max(0, start.width - diff.x);
        newSize.height = Math.max(0, start.height + diff.y);
        break;
      case 'se':
        newSize.x = start.x;
        newSize.y = start.y;
        newSize.width = Math.max(0, start.width + diff.x);
        newSize.height = Math.max(0, start.height + diff.y);
        break;
    }
    if (newSize.width <= 50 || newSize.height <= 50) {
      return;
    }
    this.changeSize({ roomObject: this.roomObject, newSize: this.updateBounding(newSize) as BoundingPosition });
  }
  private updateBounding(pos: CoordinatesPosition | BoundingPosition) {
    if (pos.x < 0) {
      pos.x = 0;
    }
    if (pos.y < 0) {
      pos.y = 0;
    }
    const width = Math.min(100, (pos as BoundingPosition)?.width ?? this.roomObject.width);
    const height = Math.min(100, (pos as BoundingPosition)?.height ?? this.roomObject.height);
    if (pos.x > this.room.roomSize.width - width) {
      pos.x = this.room.roomSize.width - width;
    }
    if (pos.y > this.room.roomSize.height - height) {
      pos.y = this.room.roomSize.height - height;
    }
    return pos;
  }
  onPointerUpHandler(e: PointerEvent) {
    const el = e.currentTarget as HTMLElement;
    el.removeEventListener('pointermove', this.onMouseMoveHandler);
    el.releasePointerCapture(e.pointerId);
  }
  //#endregion

  onTracksUpdate(ev: TrackAndElement | number | undefined | JitsiParticipant) {
    if (typeof ev === 'number' || typeof ev === 'undefined') {
      return;
    }
    let ro = this.roomObject as DesktopRoomObject;
    let videoTrackEl = ro.createdUserParticipant?.desktopTrack;
    if (videoTrackEl && videoTrackEl === ev) {
      // 追加の時
      (this.$refs.shareVideoElementRef as HTMLDivElement)?.appendChild(videoTrackEl.el);
      if (videoTrackEl.el.paused) {
        videoTrackEl.el.play();
      }
      this.isDesktopMounted = true;
    } else if (!videoTrackEl) {
      this.isDesktopMounted = false;
    }
  }
  openUrl(ev: Event) {
    if (!this.url || !this.isLocked) {
      return;
    }
    ev.stopPropagation();
    window.open(this.url, '_blank');
  }
  subWindow: Window | null = null;

  @Watch('roomObject.hidden')
  onShareScreenHiddenChange() {
    if (this.isShareScreen && this.subWindow) {
      const channel = new BroadcastChannel('screen hidden');
      channel.postMessage((this.roomObject as DesktopRoomObject).hidden);
    }
  }

  openImgInDifferentTab(ev: MouseEvent): void {
    ev?.stopPropagation();
    if (!this.isRoomObjectHover) {
      return;
    }
    if (this.subWindow && !this.subWindow.closed) {
      this.subWindow.focus();
      return;
    }
    this.subWindow?.close();
    this.subWindow = null;

    if (this.roomObject.objectType === 'image' || this.roomObject.props?.boardType === 'image') {
      const newTab = window.open();
      if (newTab) {
        let url = this.roomObject.imageBase64 ?? '';
        if (url.startsWith('/')) {
          url = location.origin + url;
        }
        newTab.document.body.innerHTML = `<img src="${url}" />`;
        this.subWindow = newTab;
      }
    } else if (this.roomObject.props?.boardType === 'iframe') {
      let url = this.roomObject.props.iframeUrl ?? '';
      if (url.startsWith('/')) {
        url = location.origin + url;
      }
      const newTab = window.open(url, '_blank');
      newTab?.focus();
    } else if (this.roomObject.objectType === 'share screen') {
      ev?.stopPropagation();
      let ro = this.roomObject as DesktopRoomObject;
      let videoTrackInfo = ro.createdUserParticipant?.desktopTrack;
      if (!videoTrackInfo) {
        return;
      }
      if (zawaroom.jitsi?.currentOpeningTrack) {
        console.warn('処理中のトラックが存在します');
      }
      if (zawaroom.jitsi) {
        zawaroom.jitsi.currentOpeningTrack = { track: videoTrackInfo.track, name: this.author };
      }
      let windowFeatures = 'popup';
      const newTab = window.open('sharescreen.html', videoTrackInfo.track.getId(), windowFeatures);
      if (newTab) {
        this.subWindow = newTab;
        newTab.addEventListener('load', () => {
          this.onShareScreenHiddenChange();
        });
      }
    }
  }
}
